import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=786d539d&scoped=true&"
var script = {}
import style0 from "./Logo.vue?vue&type=style&index=0&id=786d539d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786d539d",
  null
  
)

export default component.exports